import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {languageValues, localeKeyLong, localeKeyLongToShort} from '../constants/i18n.constants';
import {initI18nConfig} from '../config/i18n.config';
import {IdNameString, StorageService} from '@core/src/public-api';
import {PrimeNGConfig} from 'primeng/api';
import {AppConfigService} from '@services/app-config.service';
import {configVariableValues} from '@constants/config-variable-values.constants';

@Injectable({
  providedIn: 'root'
})
export class I18nService {
  private activeLangKeyLong: string;
  private storageName = 'pasi-language';
  languageValues = languageValues;

  constructor(
    private translateService: TranslateService,
    private primeNGConfig: PrimeNGConfig,
    private storageService: StorageService,
    private appConfigService: AppConfigService,
  ) {
  }

  initLang(): void {
    this.activeLangKeyLong = this.getLanguageStorage() || localeKeyLong.DEFAULT;
    this.translateService.setDefaultLang(this.activeLangKeyLong);
    this.translateService.use(this.activeLangKeyLong);
    initI18nConfig(this.activeLangKeyLong);
    this.setTranslationsPrimeng();
  }

  getActiveLanguageValues(): IdNameString[] {
    const activeLanguageLocalesConfVariable = this.appConfigService.getVariableValue(configVariableValues.ACTIVE_LANGUAGE_LOCALES);
    if (!activeLanguageLocalesConfVariable?.length) {
      return this.languageValues;
    }

    const activeLanguageLocales = activeLanguageLocalesConfVariable.split(',');
    return this.languageValues.filter(({id}) => activeLanguageLocales.includes(id));
  }

  getLanguage(): string {
    return this.activeLangKeyLong;
  }

  setLanguage(langKeyLong: string): void {
    this.setLanguageStorage(langKeyLong);
    window.location.reload();
  }

  getLanguageShort(): string {
    return localeKeyLongToShort[this.activeLangKeyLong];
  }

  getLanguageShortHyphen(): string {
    const locale = this.getLanguageShort();
    if (locale.length > 2) {
      return `${locale.slice(0, 2)}-${locale.slice(2)}`;
    }

    return locale;
  }

  getLanguageStorage(): string {
    return this.storageService.getItem(this.storageName, true);
  }

  setLanguageStorage(langKeyLong: string): void {
    this.storageService.setItem(this.storageName, langKeyLong, true);
  }

  async setTranslationsPrimeng(): Promise<void> {
    const translationsPrimeng = await this.translateService.get('primeng').toPromise();
    this.primeNGConfig.setTranslation(translationsPrimeng);
  }
}
